// extracted by mini-css-extract-plugin
module.exports = {"item":"FolderItem_item__31u-B","container":"FolderItem_container__3DZ7L"};